module.exports = "/images/Icon industry-RopesCourse.svg?a9fe5ee8e37025cc728b85df02a7a727";